import React, { useEffect, useState } from "react";
import {
  Form,
  HyperLink,
  notification,
} from "../../../components/Elements/appUtils";

import PageHeader from "../../../components/Elements/pageHeader";
import { useDispatch } from "react-redux";
import { GetEachFormFields } from "../../../components/_utils/formUtils";
import { States, gstTypeList } from "../../../components/_utils/appUtils";

import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { singleTakenFxn, updateTakenFxn } from "./action";


const EditTaken = (props) => {
    let {onClose} = props;
  const { getFieldValue,setFieldsValue } = props.form;
  let dispatch = useDispatch();
  let navigate = useNavigate();
  const [takenId, setTakenId] = useState("");
  useEffect(() => {
    checktakenId();
  }, []);

  let id;

  const checktakenId = async () => {
    let searchParams = new URLSearchParams(window.location.search);
    id = searchParams.get("_id");
    if (id) {
        getSingleTaken(id);
        setTakenId(id);
    }
  };
  const getSingleTaken = async (id) => {
    let { data, success } = await dispatch(singleTakenFxn(id));
 
    if (success) {
      setTimeout(() => {
        props.form.setFieldsValue({
            whentotake: data.whentotake,
        });
       
         
     
      }, 300);
      
      
    }
  };
 

    const handleSubmit = (e) => {
      const {form} = props;
      e.preventDefault();

      form.validateFields(async (err, valData) => {
          if (!err) {

              valData._id = takenId

              let x = await dispatch(updateTakenFxn(valData));
              if (x && x.success) {
                  console.log(x, "valdata")
                  navigate('/add-taken')
              }
          } else {
              if (err.name) {
                  notification.warning({
                      message: `Please enter Add Taken`,
                  });
                  return;
              }

            

              notification.warning({
                  message: "Fill All Required Fields",
              });
          }
      });
  };

  let inputTypes = {
    fields: [
        {
            title: "When To Take",
            dataIndex: "whentotake",
            key: "whentotake",
          },
     
     
    ],
  };

  return (
    <>
      <PageHeader title={"Edit Add Taken"}>
        <div className="card">
          <div className="card-body">
            <Form onSubmit={handleSubmit}>
              <div className="form-elements-wrapper">
                <div className={"row"}>
                  {inputTypes.fields.map((item, key) => {
                    return !item.hidden ? (
                      <div
                        className={`pb-3 ${item.span ? item.span : "col-md-6"}`}
                        key={key}
                      >
                        <GetEachFormFields {...props.form} item={item} />
                      </div>
                    ) : null;
                  })}
                </div>
              </div>

              <button type="submit" className="btn btn-gradient-primary me-2">
                Submit
              </button>
              <HyperLink
                className=" ms-4 btn btn-danger"
                link={"/add-taken"}
              >
                Cancel
              </HyperLink>
            </Form>
          </div>
        </div>
      </PageHeader>
    </>
  );
};

export default Form.create()(EditTaken);
